import * as zod from 'zod';

import { DHCommand } from '@sb/integrations/implementations/dh/comon/types/DHCommand';

export const DHPGC30060Command = DHCommand.extend({
  kind: zod.literal('DHPGC30060Command'),
});

export type DHPGC30060Command = zod.infer<typeof DHPGC30060Command>;
